<template>
  <van-popup
    v-model="isShowSelectableBank"
    round
    position="bottom"
    :style="{ height: '50%' }"
  >
    <LongListPicker
      ref="longListPicker"
      :options="bankList"
      title="选择开户行"
      label-key="bankName"
      value-key="bankId"
      :loading="loading"
      :offset="150"
      :error="isListError"
      :finished="bankList.length >= bankTotalCount"
      @on-cancel="isShowSelectableBank = false"
      @on-confirm="handleSelectBank"
      @on-search="handleSearchBank"
      @load="handleLoadMoreBankList"
    />
  </van-popup>
</template>

<script>
import Popup from 'vant/lib/popup';
import LongListPicker from '@/components/LongListPicker';
import STATUS from '@/constants/status';

import createWalletApi from '@/api/createWallet';

import 'vant/lib/popup/style';

export default {
  name: 'BankPicker',
  components: {
    LongListPicker,
    [Popup.name]: Popup,
  },
  data() {
    return {
      isShowSelectableBank: false,
      isListError: false,
      loading: false,
      bankTotalCount: 0,
      currentPage: 1,
      bankList: [],
      keyword: '',
    };
  },
  methods: {
    loadBankList() {
      this.getBankList();
      this.isShowSelectableBank = true;
    },

    async getBankList() {
      this.loading = true;
      try {
        const {
          respCode, data, respMsg, total,
        } = await createWalletApi.getBankList({
          pageSize: 15,
          pageNum: this.currentPage,
          keyword: this.keyword,
        });

        if (respCode !== STATUS.SUCCESS) throw new Error(respMsg);

        this.bankTotalCount = total;
        this.bankList.push(...data);
      } catch (e) {
        this.$dialog.toast(e.message || '操作失败');
      } finally {
        this.loading = false;
      }
    },

    handleSelectBank(bank) {
      this.isShowSelectableBank = false;
      this.$emit('on-select-bank', bank);
    },

    handleSearchBank(keyword) {
      this.keyword = keyword;
      this.currentPage = 1;
      this.bankList = [];
      this.getBankList();
    },

    handleLoadMoreBankList() {
      this.currentPage = this.currentPage + 1;
      this.getBankList();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
